import * as React from "react";
import { Button, Form, FormGroup, Input } from "reactstrap";
import ErrorMessage from "../../ErrorMessage";
import useErrorHandler from "../../../utils/Hooks/ErrorHandler";
import { isEmail } from "../../../utils/validation";
import { authEndpoints } from "../../../utils/Constants";
import { useAlert } from "../../../Services/AlertContext";
import fetch from 'cross-fetch';

const validateEmail = (
    email,
    setError
) => {

    // Validate email
    if (!isEmail(email)) {
        setError("Please enter a valid email address.");
        return false;
    }
    return true;
};


const ForgotPasswordPanel = ({ onClose }) => {
    const [userEmail, setUserEmail] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const { error, showError } = useErrorHandler(null);
    const alert = useAlert();
    return <Form
        onSubmit={async e => {
            e.preventDefault();
            setLoading(true);
            if (validateEmail(userEmail, showError)) {
                const res = await fetch(authEndpoints.requestPasswordReset, {
                    method: "POST", headers: {
                        "Content-type": "application/json"
                    }, body: JSON.stringify({ email: userEmail })
                });
                if (!res.ok) { throw new Error("Couldn't request a password change. Check your internet connection?"); }

                alert({
                    title: <h3>Password Reset</h3>,
                    body: <h5>If you have an account registered with JetBidders, we will send you a reset link to the email address provided.</h5>,
                    buttons: <Button onClick={() => { alert(); setLoading(false); onClose(); }}>Return to Log In Page</Button>
                })

            }
        }}
    >
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'centre' }}>
            <img alt='jetbidders' src={'/img/logo.png'} style={{ width: '60%', height: 'auto', marginTop: '5vh' }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'centre' }}>
            <div style={{ width: '80%' }}>
                <h3 style={{ marginTop: '5vh', marginBottom: '5vh' }}>Forgot  Password</h3>
                <FormGroup>
                    <Input size='lg'
                        type="email"
                        name="email"
                        value={userEmail}
                        placeholder="your email"
                        onChange={e => setUserEmail(e.target.value)}
                    />
                </FormGroup>

            </div>
        </div>
        <div style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
        }}>
            <div style={{ marginBottom: '50px', width: '80%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>

                <Button style={{ width: '40%' }} color='secondary' type='button' onClick={onClose} disabled={loading} >Go Back</Button>
                <Button style={{ width: '40%' }} color='primary' type="submit" disabled={loading}>
                    {loading ? "Loading..." : "Send Email"}
                </Button>
                {error && <ErrorMessage errorMessage={error} />}
            </div>
        </div>
    </Form>
}

export default ForgotPasswordPanel;